import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { type BreadcrumbListSchema } from '@cx-web/api-clients/template-api/types';
import { type FooterV2Response } from '@cx-web/domain-types';

import { type Repub } from '@cx-modules/constants';

import Logo from '../../primitives/Logo';
import { FooterV2 } from '../footer/FooterV2';
import { type CmpProps } from '../footer/types';

import { getSocialLinks, getSocialLinksUkStyle } from './social-links';

export type CxFooterProps = {
  /** Curated JSON-LD BreadcrumbList, passed through to FooterV2 for the in-footer breadcrumbs (OCGC-3445). */
  breadcrumbsDataSchema?: BreadcrumbListSchema;
  cmpProps?: CmpProps;
  footerData?: FooterV2Response;
  isAdmiralCookieBannerEnabled: boolean;
  isUkFooterStyle?: boolean;
  logo?: ReactNode;
  /** Repub-prefixed request path, passed through to FooterV2 for the in-footer breadcrumbs (OCGC-3445). */
  path?: string;
  /** Current repub — drives the breadcrumb link prefix (OCGC-3445). Optional, see `path`. */
  repub?: Repub;
  resourcesUrl: string;
};

export const CxFooter = ({
  breadcrumbsDataSchema,
  cmpProps,
  footerData,
  isAdmiralCookieBannerEnabled,
  isUkFooterStyle,
  logo,
  path,
  repub,
  resourcesUrl,
}: CxFooterProps) => {
  const { t } = useTranslation(['label']);

  return (
    <FooterV2
      breadcrumbsDataSchema={breadcrumbsDataSchema}
      cmpProps={cmpProps}
      footerData={footerData}
      isAdmiralCookieBannerEnabled={isAdmiralCookieBannerEnabled}
      isUkFooterStyle={isUkFooterStyle}
      legalAge={t('CX_LEGAL_AGE')}
      legalText={t('CX_FOOTER_LEGAL')}
      logo={logo ?? <Logo resourcesUrl={resourcesUrl} />}
      path={path}
      repub={repub}
      socialLinks={isUkFooterStyle ? getSocialLinksUkStyle(t) : getSocialLinks(t)}
    />
  );
};
